import { createFileRoute } from "@tanstack/react-router";
import WhatShouldIAskDuringConsultation from "@/pages/articles/WhatShouldIAskDuringConsultation";
export const Route = createFileRoute(
  "/what-should-i-ask-during-a-depression-treatment-consultation",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Questions for a Depression Consultation | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "What to ask during a depression treatment consultation. A checklist of questions for TMS, SAINT TMS, and SPRAVATO in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content:
            "Questions for a Depression Consultation | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "What to ask during a depression treatment consultation. A checklist of questions for TMS, SAINT TMS, and SPRAVATO in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/what-should-i-ask-during-a-depression-treatment-consultation",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/what-should-i-ask-during-a-depression-treatment-consultation",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatShouldIAskDuringConsultation />;
}
